import { render, staticRenderFns } from "./AssignedGroupList.vue?vue&type=template&id=0561c541&scoped=true&"
import script from "./AssignedGroupList.vue?vue&type=script&lang=js&"
export * from "./AssignedGroupList.vue?vue&type=script&lang=js&"
import style0 from "./AssignedGroupList.vue?vue&type=style&index=0&id=0561c541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0561c541",
  null
  
)

export default component.exports